module.exports = __webpack_public_path__ + "img/spotlight-sundul.f758189f.png";